import { customStyled, Box, Button } from '@mafc/trolly';

export const ChangeLabel = customStyled(Box)(({ theme }) => ({
  marginRight: theme.space[2],
}));

export const ChangeButton = customStyled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: theme.fontSizes[2],
  fontWeight: theme.fontWeights[6],
  height: 'auto',
  ':disabled': {
    backgroundColor: 'transparent',
  },
}));
